/* Adds the API domain to input path based on the current environment */
export const prefixPathWithAPIDomain = (path) => {
    if (process.env.NODE_ENV!=="development") return process.env.REACT_APP_SERVER_PROXY + "/" + path
    else return path
}